
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire94c2"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire94c2"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("ckaL5", function(module, exports) {

$parcel$export(module.exports, "PINK_ANGLE_COLORS", () => $bb84c280a189e0ba$export$7a003cdef7722780);
$parcel$export(module.exports, "CENTER_OF_CIRCLE", () => $bb84c280a189e0ba$export$c7609d9da8d80867);
$parcel$export(module.exports, "CIRCLE_RADIUS", () => $bb84c280a189e0ba$export$ca8f2c484d507a5d);
$parcel$export(module.exports, "INITIAL_INTERSEC_RADIUS", () => $bb84c280a189e0ba$export$71b7ee2b1d39589f);
$parcel$export(module.exports, "INITIAL_RADIANS", () => $bb84c280a189e0ba$export$95c476c8e1b0007);
$parcel$export(module.exports, "ARC_COLOR_ARR", () => $bb84c280a189e0ba$export$bdea539c223eec51);
$parcel$export(module.exports, "INFO_SLIDER_COORD", () => $bb84c280a189e0ba$export$840ec2322406bfdd);
$parcel$export(module.exports, "SLIDERS_COORD", () => $bb84c280a189e0ba$export$186dbbe504e85fe1);
$parcel$export(module.exports, "SLIDERS_COORD_OFFSET_VERTICAL", () => $bb84c280a189e0ba$export$75f2cc8245aafe09);
$parcel$export(module.exports, "THRESHOLD_RADIANS", () => $bb84c280a189e0ba$export$16d4da82cc3d15d6);
$parcel$export(module.exports, "INFO_SLIDER_ASSETS_SLUG", () => $bb84c280a189e0ba$export$2e51dc0dfab2d766);
const $bb84c280a189e0ba$export$7a003cdef7722780 = [
    0xFC99C4,
    0xF94F6F
];
const $bb84c280a189e0ba$export$c7609d9da8d80867 = {
    x: 600,
    y: 310
};
const $bb84c280a189e0ba$export$ca8f2c484d507a5d = 200;
const $bb84c280a189e0ba$export$71b7ee2b1d39589f = 145;
const $bb84c280a189e0ba$export$95c476c8e1b0007 = [
    Math.PI / 16,
    Math.PI / 4 * 3
];
const $bb84c280a189e0ba$export$bdea539c223eec51 = [
    0x000000,
    0x000000
];
const $bb84c280a189e0ba$export$840ec2322406bfdd = {
    x: 1180,
    y: 200
};
const $bb84c280a189e0ba$export$186dbbe504e85fe1 = [
    {
        x: 70,
        y: 800
    },
    {
        x: 440,
        y: 800
    },
    {
        x: 810,
        y: 800
    }
];
const $bb84c280a189e0ba$export$75f2cc8245aafe09 = [
    {
        x: -260,
        y: 400
    },
    {
        x: -260,
        y: 600
    },
    {
        x: 60,
        y: 400
    }
];
const $bb84c280a189e0ba$export$16d4da82cc3d15d6 = {
    max: Math.PI / 3 * 2,
    min: Math.PI / 9 * 5
};
const $bb84c280a189e0ba$export$2e51dc0dfab2d766 = "circle-theorem-10";

});

parcelRegister("9m5D8", function(module, exports) {

$parcel$export(module.exports, "default", () => $c1b25e149e99979c$export$2e2bcd8739ae039);

var $erVR3 = parcelRequire("erVR3");

var $lO7zi = parcelRequire("lO7zi");

var $hCdov = parcelRequire("hCdov");
class $c1b25e149e99979c$export$2e2bcd8739ae039 {
    cCoord;
    center = new (0, $lO7zi.default)("O");
    tags = [];
    constructor(cCoord, tags){
        this.cCoord = cCoord;
        this.tags = tags.map((tag)=>new (0, $lO7zi.default)(tag));
        this.updateCenter();
        (0, $erVR3.rootEventBus).on((0, $erVR3.EnumRootEventBus).startedCircleAnim, ()=>this.setAllVisible(false));
        (0, $erVR3.rootEventBus).on((0, $erVR3.EnumRootEventBus).completedCircleAnim, ()=>this.setAllVisible(true));
    }
    updateCenter = ()=>this.center.updateCoord({
            x: this.cCoord.x + 21,
            y: this.cCoord.y + 21
        });
    setAllVisible = (visible)=>[
            this.center,
            ...this.tags
        ].forEach((pTag)=>pTag.visible = visible);
    updateCoord(radians, radius) {
        const coords = (0, $hCdov.default)(this.cCoord, radians, radius + 30);
        coords.forEach((coord, cI)=>this.tags[cI].updateCoord(coord));
    }
}

});

parcelRegister("eitLW", function(module, exports) {

$parcel$export(module.exports, "default", () => $295d8ae516c805d1$export$2e2bcd8739ae039);

var $erVR3 = parcelRequire("erVR3");

var $16Wgx = parcelRequire("16Wgx");

var $16HUD = parcelRequire("16HUD");

var $gcphA = parcelRequire("gcphA");
class $295d8ae516c805d1$export$2e2bcd8739ae039 {
    CheckboxRenderer;
    isChecked = false;
    checkBoxLabel;
    handleFunc;
    constructor(coord, label, color, useCustomLayer = false, handleFunc = (label, v)=>{}){
        this.CheckboxRenderer = new (0, $gcphA.default)(color, label, useCustomLayer);
        Object.assign(this.CheckboxRenderer, coord);
        this.handleFunc = handleFunc;
        this.addInteractivity();
        (0, $erVR3.rootEventBus).on((0, $erVR3.EnumRootEventBus).startedCircleAnim, ()=>this.setVisible(false));
        (0, $erVR3.rootEventBus).on((0, $erVR3.EnumRootEventBus).completedCircleAnim, ()=>this.setVisible(true));
    }
    addToCon = (con)=>con.addChild(this.CheckboxRenderer);
    setScale = (v)=>this.CheckboxRenderer.con.scale.set(v);
    setVisible = (v)=>this.CheckboxRenderer.visible = v;
    addInteractivity() {
        const handleUpFunc = ()=>this.handleCheckbox();
        (0, $16Wgx.default)(this.CheckboxRenderer, {
            handleUpFunc: handleUpFunc
        }, (0, $16HUD.CustomCursorType).pointer, undefined, true);
    }
    handleCheckbox() {
        this.isChecked = !this.isChecked;
        this.handleFunc(this.checkBoxLabel, this.isChecked);
        this.CheckboxRenderer.drawCheckbox(this.isChecked);
    }
    getIsChecked() {
        return {
            label: this.checkBoxLabel,
            isChecked: this.isChecked
        };
    }
    setChecked(v) {
        this.isChecked = v;
        this.CheckboxRenderer.drawCheckbox(this.isChecked);
    }
}

});
parcelRegister("gcphA", function(module, exports) {

$parcel$export(module.exports, "default", () => $c6f182ab57cf75ac$export$2e2bcd8739ae039);

var $iuB9z = parcelRequire("iuB9z");

var $9ec1t = parcelRequire("9ec1t");
class $c6f182ab57cf75ac$export$2e2bcd8739ae039 extends $iuB9z.Container {
    color;
    checkboxLabel;
    Layers;
    con;
    checkedSquare;
    defaultColor;
    constructor(color, checkboxLabel, useCustomLayer = false){
        super(), this.color = color, this.checkboxLabel = checkboxLabel, this.Layers = (0, $9ec1t.default).getInstance(), this.con = this.addChild(new $iuB9z.Container()), this.checkedSquare = this.con.addChild(new $iuB9z.Graphics()), this.defaultColor = 0xFFFFFF, this.addToLayer = ()=>this.Layers.UI.addChild(this);
        this.drawCheckbox(false);
        this.addLabel();
        !useCustomLayer && this.addToLayer();
    }
    addToLayer;
    drawCheckbox(isColored) {
        const fillColor = isColored ? this.color : this.defaultColor;
        this.checkedSquare.clear().roundRect(0, -20, 40, 40, 10).fill(fillColor).stroke({
            width: 2,
            color: 0x000000
        });
    }
    addLabel() {
        const text = new $iuB9z.Text({
            text: this.checkboxLabel
        });
        text.style.fontSize = 36;
        text.style.fill = this.color;
        text.anchor.set(0, .5);
        text.x = 50;
        text.y = 0;
        this.con.addChild(text);
    }
}

});


parcelRegister("jISXQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $66faaaf67ef5cb50$export$2e2bcd8739ae039);
function $66faaaf67ef5cb50$export$2e2bcd8739ae039(dim, CENTER_OF_CIRCLE) {
    if (dim.WIDTH > dim.HEIGHT) return CENTER_OF_CIRCLE;
    return {
        x: dim.WIDTH / 2,
        y: dim.HEIGHT / 2
    };
}

});

parcelRegister("beJMG", function(module, exports) {

$parcel$export(module.exports, "getTextureBatchBindGroup", () => $24797d7b1c25d5bc$export$84c26df82650dc9b);

var $awcfo = parcelRequire("awcfo");

var $bLlTJ = parcelRequire("bLlTJ");
"use strict";
const $24797d7b1c25d5bc$var$cachedGroups = {};
function $24797d7b1c25d5bc$export$84c26df82650dc9b(textures, size, maxTextures) {
    let uid = 2166136261;
    for(let i = 0; i < size; i++){
        uid ^= textures[i].uid;
        uid = Math.imul(uid, 16777619);
        uid >>>= 0;
    }
    return $24797d7b1c25d5bc$var$cachedGroups[uid] || $24797d7b1c25d5bc$var$generateTextureBatchBindGroup(textures, size, uid, maxTextures);
}
function $24797d7b1c25d5bc$var$generateTextureBatchBindGroup(textures, size, key, maxTextures) {
    const bindGroupResources = {};
    let bindIndex = 0;
    for(let i = 0; i < maxTextures; i++){
        const texture = i < size ? textures[i] : (0, $bLlTJ.Texture).EMPTY.source;
        bindGroupResources[bindIndex++] = texture.source;
        bindGroupResources[bindIndex++] = texture.style;
    }
    const bindGroup = new (0, $awcfo.BindGroup)(bindGroupResources);
    $24797d7b1c25d5bc$var$cachedGroups[key] = bindGroup;
    return bindGroup;
}

});

parcelRegister("6RGCN", function(module, exports) {

$parcel$export(module.exports, "CanvasPool", () => $cb3b5b020b2ab749$export$e56d0a06781accc9);

var $iCGeI = parcelRequire("iCGeI");

var $NbSCN = parcelRequire("NbSCN");

var $2GH55 = parcelRequire("2GH55");
"use strict";
class $cb3b5b020b2ab749$export$62d9f0b8aada09d7 {
    constructor(canvasOptions){
        this._canvasPool = /* @__PURE__ */ Object.create(null);
        this.canvasOptions = canvasOptions || {};
        this.enableFullScreen = false;
    }
    /**
   * Creates texture with params that were specified in pool constructor.
   * @param pixelWidth - Width of texture in pixels.
   * @param pixelHeight - Height of texture in pixels.
   */ _createCanvasAndContext(pixelWidth, pixelHeight) {
        const canvas = (0, $iCGeI.DOMAdapter).get().createCanvas();
        canvas.width = pixelWidth;
        canvas.height = pixelHeight;
        const context = canvas.getContext("2d");
        return {
            canvas: canvas,
            context: context
        };
    }
    /**
   * Gets a Power-of-Two render texture or fullScreen texture
   * @param minWidth - The minimum width of the render texture.
   * @param minHeight - The minimum height of the render texture.
   * @param resolution - The resolution of the render texture.
   * @returns The new render texture.
   */ getOptimalCanvasAndContext(minWidth, minHeight, resolution = 1) {
        minWidth = Math.ceil(minWidth * resolution - 1e-6);
        minHeight = Math.ceil(minHeight * resolution - 1e-6);
        minWidth = (0, $NbSCN.nextPow2)(minWidth);
        minHeight = (0, $NbSCN.nextPow2)(minHeight);
        const key = (minWidth << 17) + (minHeight << 1);
        if (!this._canvasPool[key]) this._canvasPool[key] = [];
        let canvasAndContext = this._canvasPool[key].pop();
        if (!canvasAndContext) canvasAndContext = this._createCanvasAndContext(minWidth, minHeight);
        return canvasAndContext;
    }
    /**
   * Place a render texture back into the pool.
   * @param canvasAndContext
   */ returnCanvasAndContext(canvasAndContext) {
        const canvas = canvasAndContext.canvas;
        const { width: width, height: height } = canvas;
        const key = (width << 17) + (height << 1);
        canvasAndContext.context.resetTransform();
        canvasAndContext.context.clearRect(0, 0, width, height);
        this._canvasPool[key].push(canvasAndContext);
    }
    clear() {
        this._canvasPool = {};
    }
}
const $cb3b5b020b2ab749$export$e56d0a06781accc9 = new $cb3b5b020b2ab749$export$62d9f0b8aada09d7();
(0, $2GH55.GlobalResourceRegistry).register($cb3b5b020b2ab749$export$e56d0a06781accc9);

});

parcelRegister("hPtJY", function(module, exports) {
// shim for using process in browser
var $cfae44f0dfdf62c0$var$process = module.exports = {};
// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.
var $cfae44f0dfdf62c0$var$cachedSetTimeout;
var $cfae44f0dfdf62c0$var$cachedClearTimeout;
function $cfae44f0dfdf62c0$var$defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function $cfae44f0dfdf62c0$var$defaultClearTimeout() {
    throw new Error('clearTimeout has not been defined');
}
(function() {
    try {
        if (typeof setTimeout === 'function') $cfae44f0dfdf62c0$var$cachedSetTimeout = setTimeout;
        else $cfae44f0dfdf62c0$var$cachedSetTimeout = $cfae44f0dfdf62c0$var$defaultSetTimout;
    } catch (e) {
        $cfae44f0dfdf62c0$var$cachedSetTimeout = $cfae44f0dfdf62c0$var$defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') $cfae44f0dfdf62c0$var$cachedClearTimeout = clearTimeout;
        else $cfae44f0dfdf62c0$var$cachedClearTimeout = $cfae44f0dfdf62c0$var$defaultClearTimeout;
    } catch (e) {
        $cfae44f0dfdf62c0$var$cachedClearTimeout = $cfae44f0dfdf62c0$var$defaultClearTimeout;
    }
})();
function $cfae44f0dfdf62c0$var$runTimeout(fun) {
    if ($cfae44f0dfdf62c0$var$cachedSetTimeout === setTimeout) //normal enviroments in sane situations
    return setTimeout(fun, 0);
    // if setTimeout wasn't available but was latter defined
    if (($cfae44f0dfdf62c0$var$cachedSetTimeout === $cfae44f0dfdf62c0$var$defaultSetTimout || !$cfae44f0dfdf62c0$var$cachedSetTimeout) && setTimeout) {
        $cfae44f0dfdf62c0$var$cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $cfae44f0dfdf62c0$var$cachedSetTimeout(fun, 0);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return $cfae44f0dfdf62c0$var$cachedSetTimeout.call(null, fun, 0);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return $cfae44f0dfdf62c0$var$cachedSetTimeout.call(this, fun, 0);
        }
    }
}
function $cfae44f0dfdf62c0$var$runClearTimeout(marker) {
    if ($cfae44f0dfdf62c0$var$cachedClearTimeout === clearTimeout) //normal enviroments in sane situations
    return clearTimeout(marker);
    // if clearTimeout wasn't available but was latter defined
    if (($cfae44f0dfdf62c0$var$cachedClearTimeout === $cfae44f0dfdf62c0$var$defaultClearTimeout || !$cfae44f0dfdf62c0$var$cachedClearTimeout) && clearTimeout) {
        $cfae44f0dfdf62c0$var$cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $cfae44f0dfdf62c0$var$cachedClearTimeout(marker);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return $cfae44f0dfdf62c0$var$cachedClearTimeout.call(null, marker);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return $cfae44f0dfdf62c0$var$cachedClearTimeout.call(this, marker);
        }
    }
}
var $cfae44f0dfdf62c0$var$queue = [];
var $cfae44f0dfdf62c0$var$draining = false;
var $cfae44f0dfdf62c0$var$currentQueue;
var $cfae44f0dfdf62c0$var$queueIndex = -1;
function $cfae44f0dfdf62c0$var$cleanUpNextTick() {
    if (!$cfae44f0dfdf62c0$var$draining || !$cfae44f0dfdf62c0$var$currentQueue) return;
    $cfae44f0dfdf62c0$var$draining = false;
    if ($cfae44f0dfdf62c0$var$currentQueue.length) $cfae44f0dfdf62c0$var$queue = $cfae44f0dfdf62c0$var$currentQueue.concat($cfae44f0dfdf62c0$var$queue);
    else $cfae44f0dfdf62c0$var$queueIndex = -1;
    if ($cfae44f0dfdf62c0$var$queue.length) $cfae44f0dfdf62c0$var$drainQueue();
}
function $cfae44f0dfdf62c0$var$drainQueue() {
    if ($cfae44f0dfdf62c0$var$draining) return;
    var timeout = $cfae44f0dfdf62c0$var$runTimeout($cfae44f0dfdf62c0$var$cleanUpNextTick);
    $cfae44f0dfdf62c0$var$draining = true;
    var len = $cfae44f0dfdf62c0$var$queue.length;
    while(len){
        $cfae44f0dfdf62c0$var$currentQueue = $cfae44f0dfdf62c0$var$queue;
        $cfae44f0dfdf62c0$var$queue = [];
        while(++$cfae44f0dfdf62c0$var$queueIndex < len)if ($cfae44f0dfdf62c0$var$currentQueue) $cfae44f0dfdf62c0$var$currentQueue[$cfae44f0dfdf62c0$var$queueIndex].run();
        $cfae44f0dfdf62c0$var$queueIndex = -1;
        len = $cfae44f0dfdf62c0$var$queue.length;
    }
    $cfae44f0dfdf62c0$var$currentQueue = null;
    $cfae44f0dfdf62c0$var$draining = false;
    $cfae44f0dfdf62c0$var$runClearTimeout(timeout);
}
$cfae44f0dfdf62c0$var$process.nextTick = function(fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) for(var i = 1; i < arguments.length; i++)args[i - 1] = arguments[i];
    $cfae44f0dfdf62c0$var$queue.push(new $cfae44f0dfdf62c0$var$Item(fun, args));
    if ($cfae44f0dfdf62c0$var$queue.length === 1 && !$cfae44f0dfdf62c0$var$draining) $cfae44f0dfdf62c0$var$runTimeout($cfae44f0dfdf62c0$var$drainQueue);
};
// v8 likes predictible objects
function $cfae44f0dfdf62c0$var$Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
$cfae44f0dfdf62c0$var$Item.prototype.run = function() {
    this.fun.apply(null, this.array);
};
$cfae44f0dfdf62c0$var$process.title = 'browser';
$cfae44f0dfdf62c0$var$process.browser = true;
$cfae44f0dfdf62c0$var$process.env = {};
$cfae44f0dfdf62c0$var$process.argv = [];
$cfae44f0dfdf62c0$var$process.version = ''; // empty string to avoid regexp issues
$cfae44f0dfdf62c0$var$process.versions = {};
function $cfae44f0dfdf62c0$var$noop() {}
$cfae44f0dfdf62c0$var$process.on = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.addListener = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.once = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.off = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.removeListener = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.removeAllListeners = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.emit = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.prependListener = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.prependOnceListener = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.listeners = function(name) {
    return [];
};
$cfae44f0dfdf62c0$var$process.binding = function(name) {
    throw new Error('process.binding is not supported');
};
$cfae44f0dfdf62c0$var$process.cwd = function() {
    return '/';
};
$cfae44f0dfdf62c0$var$process.chdir = function(dir) {
    throw new Error('process.chdir is not supported');
};
$cfae44f0dfdf62c0$var$process.umask = function() {
    return 0;
};

});


var $75RpY = parcelRequire("75RpY");

var $75RpY = parcelRequire("75RpY");

var $erVR3 = parcelRequire("erVR3");

var $fGH3X = parcelRequire("fGH3X");

var $iiVV4 = parcelRequire("iiVV4");

var $aPdzS = parcelRequire("aPdzS");

var $5ehzb = parcelRequire("5ehzb");

var $ckaL5 = parcelRequire("ckaL5");

var $iuB9z = parcelRequire("iuB9z");
var $c178b51eec2f53da$export$cb883390c27ec6dd = /*#__PURE__*/ function(EnumEventBus) {
    EnumEventBus["rotateChords"] = "ROTATE_CHORDS";
    EnumEventBus["moveChordA"] = "MOVE_CHORD_A";
    EnumEventBus["moveChordB"] = "MOVE_CHORD_B";
    EnumEventBus["setPointChecklist"] = "SET_POINT_CHECK_LIST";
    return EnumEventBus;
}({});
const $c178b51eec2f53da$export$f6644f0f2c90144b = new (0, $iuB9z.EventEmitter)();



var $hCdov = parcelRequire("hCdov");

var $2h5MD = parcelRequire("2h5MD");

var $darcK = parcelRequire("darcK");

var $ckaL5 = parcelRequire("ckaL5");
function $7e2bc522949faedd$export$8eaa7687b309599b(cCoord, circleRadius, pointRadian, intersecRadius) {
    if (!cCoord || !circleRadius || !pointRadian || !intersecRadius) return Array(3).fill({
        x: 0,
        y: 0
    });
    const intersecCoord = (0, $hCdov.default)(cCoord, [
        pointRadian
    ], intersecRadius)[0];
    const sideLength = Math.sqrt(Math.pow(circleRadius, 2) - Math.pow(intersecRadius, 2));
    const getCoord = (radian)=>({
            x: intersecCoord.x + Math.cos(radian) * sideLength,
            y: intersecCoord.y + Math.sin(radian) * sideLength
        });
    return [
        getCoord(pointRadian + Math.PI / 2),
        intersecCoord,
        getCoord(pointRadian - Math.PI / 2)
    ];
}
function $7e2bc522949faedd$export$d236dac7b1faaeec(cCoord, chordA, chordB) {
    // y = m * x + b
    const slopeA = Math.tan((0, $darcK.normalizeRadian)((0, $2h5MD.default)(chordA[1], cCoord) + Math.PI / 2));
    const slopeB = Math.tan((0, $darcK.normalizeRadian)((0, $2h5MD.default)(chordB[1], cCoord) + Math.PI / 2));
    // b = y - m * x
    const bA = chordA[1].y - slopeA * chordA[1].x;
    const bB = chordB[1].y - slopeB * chordB[1].x;
    // x = (b2 - b1) / (m1 - m2)
    const x = Number(((bB - bA) / (slopeA - slopeB)).toFixed(2));
    const y = Number((slopeB * x + bB).toFixed(2));
    return {
        x: x,
        y: y
    };
}
function $7e2bc522949faedd$export$d52692c6983e7d02(a, b) {
    let delta = a - b;
    while(delta > Math.PI)delta -= 2 * Math.PI;
    while(delta < -Math.PI)delta += 2 * Math.PI;
    return delta;
}
function $7e2bc522949faedd$export$f6017383cfd26c44(pointInfoArr, RedPointsArr, pointRadians) {
    let _pointInfoArr = [
        ...pointInfoArr
    ];
    if (pointInfoArr.length === 1) {
        const index = RedPointsArr.findIndex((point)=>point.tag === pointInfoArr[0].pTag);
        const otherIndex = index === 0 ? 1 : 0;
        const firstRadian = (0, $darcK.normalizeRadian)(pointInfoArr[0].radian);
        const secondOriginalRadian = (0, $darcK.normalizeRadian)(pointRadians[otherIndex]);
        const delta = $7e2bc522949faedd$export$d52692c6983e7d02(firstRadian, secondOriginalRadian);
        let secondRadian = secondOriginalRadian;
        if (Math.abs(delta) > (0, $ckaL5.THRESHOLD_RADIANS).max) // Çok uzaksa, max sınırına getir
        secondRadian = delta > 0 ? firstRadian - (0, $ckaL5.THRESHOLD_RADIANS).max : firstRadian + (0, $ckaL5.THRESHOLD_RADIANS).max;
        else if (Math.abs(delta) < (0, $ckaL5.THRESHOLD_RADIANS).min) // Çok yakınsa, min mesafeye aç
        secondRadian = delta > 0 ? firstRadian - (0, $ckaL5.THRESHOLD_RADIANS).min : firstRadian + (0, $ckaL5.THRESHOLD_RADIANS).min;
        _pointInfoArr.push({
            pTag: RedPointsArr[otherIndex].tag,
            radian: secondRadian
        });
    }
    return _pointInfoArr;
}


class $d45c68a5e414045c$export$2e2bcd8739ae039 extends (0, $5ehzb.default) {
    intersecLA = (0, $ckaL5.INITIAL_INTERSEC_RADIUS);
    intersecLB = (0, $ckaL5.INITIAL_INTERSEC_RADIUS);
    intersecPoint = new (0, $aPdzS.default)({
        x: -100,
        y: -100
    });
    chordACoords;
    chordBCoords;
    pointCheckList = [];
    tags = [];
    constructor(cCoord){
        super(cCoord, (0, $ckaL5.CIRCLE_RADIUS), (0, $ckaL5.INITIAL_RADIANS));
        this.setCoord();
        this.draw();
        [this.chordACoords, this.chordBCoords] = this.getInitialChordCoords();
        const intersec = (0, $7e2bc522949faedd$export$d236dac7b1faaeec)(this.cCoord, this.chordACoords, this.chordBCoords);
        this.intersecPoint.draw(intersec);
        this.tags = this.getRedPoints().map((p)=>p.tag);
        (0, $c178b51eec2f53da$export$f6644f0f2c90144b).on((0, $c178b51eec2f53da$export$cb883390c27ec6dd).setPointChecklist, (l)=>this.pointCheckList = l);
        (0, $c178b51eec2f53da$export$f6644f0f2c90144b).on((0, $c178b51eec2f53da$export$cb883390c27ec6dd).rotateChords, (v)=>this.handleRotateChords(v));
        (0, $c178b51eec2f53da$export$f6644f0f2c90144b).on((0, $c178b51eec2f53da$export$cb883390c27ec6dd).moveChordA, (v)=>this.handleMoveChordA(v));
        (0, $c178b51eec2f53da$export$f6644f0f2c90144b).on((0, $c178b51eec2f53da$export$cb883390c27ec6dd).moveChordB, (v)=>this.handleMoveChordB(v));
    }
    genChordInitialCoords = (rad, intersec)=>(0, $7e2bc522949faedd$export$8eaa7687b309599b)(this.cCoord, (0, $ckaL5.CIRCLE_RADIUS), rad, intersec);
    getInitialIntersecCoord = (initialCoords)=>(0, $7e2bc522949faedd$export$d236dac7b1faaeec)(this.cCoord, initialCoords[0], initialCoords[1]);
    setIntersecPointInitial = (intersec)=>Object.assign(this.intersecPoint, intersec);
    getInitialChordCoords = ()=>[
            this.genChordInitialCoords((0, $ckaL5.INITIAL_RADIANS)[0], (0, $ckaL5.INITIAL_INTERSEC_RADIUS)),
            this.genChordInitialCoords((0, $ckaL5.INITIAL_RADIANS)[1], (0, $ckaL5.INITIAL_INTERSEC_RADIUS))
        ];
    getChordsCoords = ()=>[
            this.chordACoords,
            this.chordBCoords
        ];
    getIntersecCoord = ()=>({
            x: this.intersecPoint.x,
            y: this.intersecPoint.y
        });
    getIntersecPoint = ()=>this.intersecPoint;
    setIntersecPointVisible = (v)=>this.intersecPoint.visible = v;
    setRadian(_pointInfoArr, isSlider) {
        const pointInfoArr = (0, $7e2bc522949faedd$export$f6017383cfd26c44)(_pointInfoArr, this.RedPointsArr, this.pointRadians);
        pointInfoArr.forEach((pointInfo)=>pointInfo.pTag == this.tags[0] ? this.chordACoords = (0, $7e2bc522949faedd$export$8eaa7687b309599b)(this.cCoord, (0, $ckaL5.CIRCLE_RADIUS), pointInfo.radian, this.intersecLA) : this.chordBCoords = (0, $7e2bc522949faedd$export$8eaa7687b309599b)(this.cCoord, (0, $ckaL5.CIRCLE_RADIUS), pointInfo.radian, this.intersecLB));
        if (this.intersecPoint.visible) {
            const intersec = (0, $7e2bc522949faedd$export$d236dac7b1faaeec)(this.cCoord, this.chordACoords, this.chordBCoords);
            this.intersecPoint.draw(intersec);
        }
        this._setRadian(pointInfoArr, isSlider);
    }
    handleRotateChords(v) {
        const points = this.getRedPoints();
        const radians = this.getRefRadians();
        const generateOffsetRadian = (v)=>Math.PI / 300 * v;
        const pointInfoArr = this.pointCheckList.map((e, eI)=>this.pointRefRadians[eI] + (e ? generateOffsetRadian(v) : 0)).map((r, rI)=>({
                pTag: points[rI].tag,
                radian: r
            })).filter((pointInfo, pII)=>pointInfo.radian != radians[pII]);
        this.setRadian(pointInfoArr, true);
    }
    handleMoveChordA(v) {
        this.intersecLA = Math.floor(v * .35 + (0, $ckaL5.INITIAL_INTERSEC_RADIUS));
        const pointInfoArr = this.getCurrRedPointInfo(0);
        this.setRadian(pointInfoArr, true);
    }
    handleMoveChordB(v) {
        this.intersecLB = Math.floor(v * .35 + (0, $ckaL5.INITIAL_INTERSEC_RADIUS));
        const pointInfoArr = this.getCurrRedPointInfo(1);
        this.setRadian(pointInfoArr, true);
    }
    getCurrRedPointInfo(index) {
        const point = this.RedPointsArr[index];
        const radian = this.pointRadians[index];
        return [
            {
                pTag: point.tag,
                radian: radian
            }
        ];
    }
}



var $9m5D8 = parcelRequire("9m5D8");
class $10084f59dd4f1dca$export$2e2bcd8739ae039 extends (0, $9m5D8.default) {
    constructor(cCoord){
        super(cCoord, []);
    }
}



var $d0yDD = parcelRequire("d0yDD");

var $erVR3 = parcelRequire("erVR3");
class $4f567b0a2cb9d20f$export$2e2bcd8739ae039 {
    lines = [
        new (0, $d0yDD.default)({
            color: 0x21D4FE
        }),
        new (0, $d0yDD.default)({
            color: 0x21D4FE
        }),
        new (0, $d0yDD.default)({
            color: 0xB06EFE
        }),
        new (0, $d0yDD.default)({
            color: 0xB06EFE
        })
    ];
    constructor(){
        (0, $erVR3.rootEventBus).on((0, $erVR3.EnumRootEventBus).startedCircleAnim, ()=>this.clearAll());
    }
    clearAll = ()=>this.lines.forEach((l)=>l.clear());
    draw(intersecCoord, chordsCoords) {
        const chordA = chordsCoords[0];
        const chordB = chordsCoords[1];
        this.lines[0].draw(chordA[0], chordA[2]);
        this.lines[1].draw(chordA[1], intersecCoord);
        this.lines[2].draw(chordB[0], chordB[2]);
        this.lines[3].draw(chordB[1], intersecCoord);
    }
}



var $eitLW = parcelRequire("eitLW");

var $b2sIL = parcelRequire("b2sIL");

var $ckaL5 = parcelRequire("ckaL5");

const $852b590a887923df$var$SliderGen = [
    {
        head: "move chord A",
        colors: {
            bgColor: 0x21D4FE,
            barColor: 0x000000,
            buttonColor: 0x21D4FE
        },
        keepCurrSlider: true,
        onUpdate: (v)=>(0, $c178b51eec2f53da$export$f6644f0f2c90144b).emit((0, $c178b51eec2f53da$export$cb883390c27ec6dd).moveChordA, v - 100)
    },
    {
        head: "move chord B",
        colors: {
            bgColor: 0xB5A1FF,
            barColor: 0x000000,
            buttonColor: 0xB5A1FF
        },
        keepCurrSlider: true,
        onUpdate: (v)=>(0, $c178b51eec2f53da$export$f6644f0f2c90144b).emit((0, $c178b51eec2f53da$export$cb883390c27ec6dd).moveChordB, v - 100)
    },
    {
        head: "rotate chords",
        subHead: "(select which one to use)",
        colors: {
            bgColor: 0xBFBFBF,
            barColor: 0x000000,
            buttonColor: 0x000000
        },
        onUpdate: (v)=>(0, $c178b51eec2f53da$export$f6644f0f2c90144b).emit((0, $c178b51eec2f53da$export$cb883390c27ec6dd).rotateChords, v - 100)
    }
];
const $852b590a887923df$var$pointName = [
    "Chord A",
    "Chord B"
];
class $852b590a887923df$export$2e2bcd8739ae039 extends (0, $b2sIL.default) {
    pointCheckboxes = [];
    pointChecklist = Array(2).fill(false);
    constructor(){
        super($852b590a887923df$var$SliderGen, (0, $ckaL5.SLIDERS_COORD), (0, $ckaL5.SLIDERS_COORD_OFFSET_VERTICAL));
        this.addCheckBoxes();
    }
    handleCheckbox(index, v) {
        this.pointChecklist[index] = v;
        (0, $c178b51eec2f53da$export$f6644f0f2c90144b).emit((0, $c178b51eec2f53da$export$cb883390c27ec6dd).setPointChecklist, this.pointChecklist);
    }
    addCheckBoxes() {
        const coords = $852b590a887923df$var$getPointCheckboxCoords(this.dim);
        this.pointCheckboxes = Array(2).fill((0, $ckaL5.PINK_ANGLE_COLORS)[0]).map((e, eI)=>new (0, $eitLW.default)(coords[eI], $852b590a887923df$var$pointName[eI], e, false, (label, v)=>this.handleCheckbox(eI, v)));
        this.dim.WIDTH < this.dim.HEIGHT && this.pointCheckboxes.forEach((cbox)=>cbox.setScale(.8));
    }
}
function $852b590a887923df$var$getPointCheckboxCoords(dim) {
    const coordHorizontal = [
        {
            x: 1135,
            y: 775
        },
        {
            x: 1135,
            y: 825
        }
    ];
    const getCoordHorizontal = (eI)=>coordHorizontal[eI];
    const getCoordVertical = (eI)=>({
            x: dim.WIDTH / 2 + 35 + (eI > 1 ? 150 : 0),
            y: dim.HEIGHT / 2 + 520 + (eI % 2 == 1 ? 40 : 0)
        });
    const coords = Array(2).fill(null).map((e, eI)=>dim.WIDTH > dim.HEIGHT ? getCoordHorizontal(eI) : getCoordVertical(eI == 1 ? eI + 1 : eI));
    return coords;
}



var $ckaL5 = parcelRequire("ckaL5");

var $jISXQ = parcelRequire("jISXQ");

var $3DpJv = parcelRequire("3DpJv");

var $erVR3 = parcelRequire("erVR3");

var $iD90R = parcelRequire("iD90R");

var $ckaL5 = parcelRequire("ckaL5");

var $darcK = parcelRequire("darcK");
async function $c3891ae258d41b0e$export$2721aded6352b5ea(context, onComp) {
    const { circle: circle, LineManager: LineManager, PointManager: PointManager, cCoord: cCoord } = context;
    const centerPoint = PointManager.getPoints()[0];
    const intersecPoint = PointManager.getIntersecPoint();
    const chordsCoords = PointManager.getInitialChordCoords();
    const intersecCoord = PointManager.getInitialIntersecCoord(chordsCoords);
    const chordACoords = chordsCoords[0];
    const chordBCoords = chordsCoords[1];
    const RedPoints = PointManager.getRedPoints();
    const initialRadian = PointManager.getInitialRadians();
    PointManager.setIntersecPointVisible(false);
    PointManager.setIntersecPointInitial(intersecCoord);
    circle.setRadians([
        (0, $ckaL5.INITIAL_RADIANS)[0],
        (0, $ckaL5.INITIAL_RADIANS)[0]
    ]);
    (0, $iD90R.drawPointsAnim)([
        centerPoint
    ]);
    await (0, $iD90R.drawCircleAnim)(circle, (0, $ckaL5.INITIAL_RADIANS)[0] + Math.PI * 2, 0, true, cCoord);
    await (0, $iD90R.drawPointsAnim)([
        intersecPoint
    ]);
    await (0, $iD90R.drawLineAnim)(LineManager.lines[0], intersecCoord, chordACoords[2]);
    await (0, $iD90R.drawLineAnim)(LineManager.lines[2], intersecCoord, chordBCoords[0]);
    await (0, $iD90R.rotateCircleAnim)((v)=>PointManager.setRadian(Array(2).fill("").map((_, rI)=>({
                pTag: RedPoints[rI].tag,
                radian: (0, $darcK.normalizeRadian)(initialRadian[rI] + v)
            }))));
    onComp();
}



var $e8wW1 = parcelRequire("e8wW1");

var $ckaL5 = parcelRequire("ckaL5");
class $cc4ef6574ccf8798$export$2e2bcd8739ae039 {
    PointManager;
    LineManager;
    circle;
    cCoord;
    constructor(PointManager, LineManager, circle, cCoord){
        this.PointManager = PointManager;
        this.LineManager = LineManager;
        this.circle = circle;
        this.cCoord = cCoord;
        this.addCircAnimBut = ()=>new (0, $e8wW1.default)((0, $ckaL5.INFO_SLIDER_COORD), ()=>this.runAnimations());
        this.addCircAnimBut();
    }
    addCircAnimBut;
    runAnimations() {
        (0, $erVR3.rootEventBus).emit((0, $erVR3.EnumRootEventBus).startedCircleAnim);
        const context = {
            PointManager: this.PointManager,
            LineManager: this.LineManager,
            circle: this.circle,
            cCoord: this.cCoord
        };
        (0, $c3891ae258d41b0e$export$2721aded6352b5ea)(context, ()=>{
            (0, $erVR3.rootEventBus).emit((0, $erVR3.EnumRootEventBus).getCircleCoord, {
                x: this.circle.x,
                y: this.circle.y
            });
            (0, $erVR3.rootEventBus).emit((0, $erVR3.EnumRootEventBus).completedCircleAnim);
        });
    }
}


class $52d99ce19abdbcf9$export$2e2bcd8739ae039 {
    Game = (0, $75RpY.default).getInstance();
    circleRadius = (0, $ckaL5.CIRCLE_RADIUS);
    cCoord = (0, $jISXQ.default)(this.Game.getDim(), (0, $ckaL5.CENTER_OF_CIRCLE));
    PointManager = new (0, $d45c68a5e414045c$export$2e2bcd8739ae039)(this.cCoord);
    PointTagManager = new (0, $10084f59dd4f1dca$export$2e2bcd8739ae039)(this.cCoord);
    LineManager = new (0, $4f567b0a2cb9d20f$export$2e2bcd8739ae039)();
    circle = new (0, $iiVV4.default)(this.cCoord, (0, $ckaL5.INITIAL_RADIANS), (0, $ckaL5.ARC_COLOR_ARR));
    guideText = new (0, $3DpJv.default)(undefined, true);
    InfoSlider = new (0, $fGH3X.default)((0, $ckaL5.INFO_SLIDER_COORD));
    SliderManager = new (0, $852b590a887923df$export$2e2bcd8739ae039)();
    CircleAnimationManager;
    constructor(){
        this.CircleAnimationManager = new (0, $cc4ef6574ccf8798$export$2e2bcd8739ae039)(this.PointManager, this.LineManager, this.circle, this.cCoord);
        this.drawElements();
        (0, $erVR3.rootEventBus).on((0, $erVR3.EnumRootEventBus).drawElements, ()=>this.drawElements());
    }
    drawElements() {
        const radians = this.PointManager.getRadians();
        const chordsCoords = this.PointManager.getChordsCoords();
        const intersecCoord = this.PointManager.getIntersecCoord();
        this.circle.draw({
            radians: radians,
            radius: this.circleRadius
        });
        this.LineManager.draw(intersecCoord, chordsCoords);
    }
}



var $ckaL5 = parcelRequire("ckaL5");
const $f44b019f73257e8b$var$canvas = document.querySelector("#canvas");
if ($f44b019f73257e8b$var$canvas) window.context = new (0, $75RpY.default)($f44b019f73257e8b$var$canvas, (0, $ckaL5.INFO_SLIDER_ASSETS_SLUG), ()=>new (0, $52d99ce19abdbcf9$export$2e2bcd8739ae039)());
else console.error("Canvas is not found");


//# sourceMappingURL=index.5c745c34.js.map
